import React from "react";
import cx from "classnames";
import {ResetFilterButton} from "@components/elements/ResetFilterButton";

export interface IOption {
    getValue(): any
}

export interface IMultiSelectOption {
    getSlug(): string

    getLabel(): string
}


export interface ILanguageOption extends IOption, IMultiSelectOption {
    slug: string,
    label: string,
    count?: number
}

export interface ITagOption extends IOption, IMultiSelectOption {
    slug: string,
    label: string,
    count?: number
}


export class LanguageOption implements ILanguageOption {
    slug: string;
    label: string;
    count?: number;

    constructor(slug: string, label: string, count?: number) {
        this.slug = slug;
        this.label = label;
        this.count = count;
    }

    getValue(): string {
        return this.slug;
    }

    getSlug(): string {
        return this.slug;
    }

    getLabel(): string {
        return this.label;
    }

    static fromJson(string: string): LanguageOption {
        return new LanguageOption(JSON.parse(string).slug, JSON.parse(string).label);
    }

    toJson(): string {
        return JSON.stringify(this);
    }
}

export class TagOption implements ITagOption {
    slug: string;
    label: string;
    count?: number;

    constructor(slug: string, label: string, count?: number) {
        this.slug = slug;
        this.label = label;
        this.count = count;
    }

    getValue(): string {
        return this.slug;
    }

    getSlug(): string {
        return this.slug;
    }

    getLabel(): string {
        return this.label;
    }

    static fromJson(string: string): TagOption {
        return new TagOption(JSON.parse(string).slug, JSON.parse(string).label);
    }

    toJson(): string {
        return JSON.stringify(this);
    }
}


interface IFiltersToolbarProps {
    className: string

    onResetFilters?: () => void
    onAdvancedFilters?: () => void
    onResetFiltersAskForConfirmation?: boolean

    activeFilters: number

    children?: React.ReactNode

    filtersOpen?: boolean
}


export default class FiltersToolbar extends React.Component<IFiltersToolbarProps> {

    constructor(props: IFiltersToolbarProps) {
        super(props);
    }

    render() {
        return (
            // expands to take full height of parent
            <div className={this.props.className}>
                <div className="flex place-content-center gap-4 grow-0 flex-row
                                z-20
                                ">
                    {this.props.children}
                    {this.props.onAdvancedFilters && (
                        <button
                            className={cx(
                                "inline-flex items-center gap-2 px-3 py-2 rounded-md border text-sm font-medium transition-colors",
                                this.props.filtersOpen || this.props.activeFilters > 0
                                    ? "border-indigo-500 text-indigo-700 dark:text-indigo-300 bg-white dark:bg-gray-800 shadow-sm"
                                    : "border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
                            )}
                            onClick={() => {
                                this.props.onAdvancedFilters?.()
                            }}
                        >
                            <span>{this.props.filtersOpen ? 'Hide filters' : 'Filters'} ({this.props.activeFilters})</span>
                        </button>
                    )}
                    <ResetFilterButton
                        className="text-gray-900 dark:text-gray-100"
                        askConfirmation={this.props.onResetFiltersAskForConfirmation}
                        enabled={this.props.onResetFilters !== undefined}
                        onReset={() => this.props.onResetFilters?.()}
                    />
                </div>
            </div>
        )
    }
}
